window.ajaxCart = window.ajaxCart || {};
var shopCurrency = window.shopCurrency || '£';

const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartModalClose: '.js-ajax-cart-modal-close', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartDrawerTriggermobile: '.js-ajax-cart-drawer-trigger-mobile', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.js-ajax-cart-counter', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartDrawerTriggermobile = document.querySelector(defaults.cartDrawerTriggermobile);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

const Getfreeproduct = localStorage.getItem('addOnfree');

if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}
  
for (let i = 0; i < addToCart.length; i++) {

    addToCart[i].addEventListener('click', function(event) {

        event.preventDefault();
        const formID = $(this).closest('.product-page-content').find('form').attr("id");
        //console.log('cart formid',formID);

        addProductToCart(formID);

    });

}

function addProductToCart(formID) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });
}

// Utility function to update all cart count elements
function updateCartCount(count) {
    // Update all .cart_cnt elements
    $('.cart_cnt').html(count);
    $('.js-ajax-cart-counter').html(count);
    // Update the cartCounter variable if present
    if (typeof cartCounter !== 'undefined' && cartCounter) {
        cartCounter.innerHTML = count;
    }
}

document.addEventListener('DOMContentLoaded', function() {
    fetchCart(); // Always update cart count on page load
});

function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            window.cartData = cart;
            updateCartCount(cart.item_count);

            var subtotal_price = cart.total_price/100;
            var total_price = (subtotal_price.toFixed(2).replace(".00", ""));
            var Total_Price = (total_price.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            $('.total_price').html(Total_Price);

            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = "Haven't found anything yet? Why not speak to one our knowledgeable and friendly team <a href='https://lylies.com/pages/contact'><b> here.</b></a>";
            } else {
                renderCart(cart);
                newupdateQtu();

                // --- FREE PRODUCT LOGIC ---
                var freeProductId = localStorage.getItem('addOnfree');
                var freeProductThreshold = parseInt(localStorage.getItem('addOnPrice')) || 0;
                var hasFreeProduct = cart.items.some(item => String(item.id) === String(freeProductId));

                if (cart.total_price >= freeProductThreshold && freeProductId && !hasFreeProduct) {
                    // Add free product if not present and threshold met
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: {
                            quantity: 1,
                            id: freeProductId,
                            properties: { "Add on": "free" }
                        },
                        dataType: 'json',
                        success: function() {
                            fetchCart(); // Refresh cart after adding free product
                        }
                    });
                }
            }
        }
    });
}

function changeItem(line, callback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + line,
        dataType: 'json',
        success: function(cart) {
            updateCartCount(cart.item_count);
            fetchCart(); // Always update UI from server
        }
    });
}

function addToCartOk(product) {
    $(cartModalContent).html(product.title + ' was added to the cart!');
    openCartDrawer();
    openCartOverlay();
    fetchCart(); // Only update cart from server
}

function addToCartFail() {
  $(cartModalContent).html('The product you are trying to add is out of stock.');
   openCartDrawer();
    openCartOverlay();
}

function renderCart(cart) {
    clearCartDrawer();
    let visualSubtotal = 0;
    cart.items.forEach(function(item, index) {
        var line_price = item.line_price/100;
        var final_line_price = (line_price.toFixed(2).replace(".00", ""));
        var priceItem = item.price/100;
        var item_price = (priceItem.toFixed(2).replace(".00", ""));
        var Item__price = (item_price.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        var Item__title = (item.title.replace("Y", "y"));

        var product_List=[];
        var proProperties = (item.properties); 
        jQuery.each(proProperties, function(i, val) {
            var classengrav = (i.replace("  ", "_"));
            if(val){
                product_List.push('<div id="Engrav_option" data-attr="'+ classengrav +'">'+ i + ': ' + val + '</div>');
            }
        });
        if(proProperties){
            var engaravPrice = item.properties._boldVariantPrices/100;
            var removemoney = (engaravPrice.toFixed(2));
            var parsengarav = parseFloat(removemoney);
            var parasemoney = parseFloat(item_price);
            if(parsengarav && parasemoney){
                var tengravotal = (+parsengarav) + (+parasemoney);
            }else{
                var tengravotal = (+0) + (+parasemoney);
            }
        }else{
            var tengravotal = item_price;
        }

        // --- FREE PRODUCT LOGIC ---
        let isFree = item.properties && item.properties['Add on'] === 'free';
        let displayPrice;
        let freeNote = '';
        var freeProductThreshold = parseInt(localStorage.getItem('addOnPrice')) || 0;
        if (isFree) {
            if (cart.total_price >= freeProductThreshold) {
                if (item.quantity > 1) {
                    let mainPrice = (item.price / 100).toFixed(2).replace('.00', '');
                    displayPrice = mainPrice;
                    freeNote = `<div class="free-product-note">1 item free, ${item.quantity - 1} at £${mainPrice} each</div>`;
                    visualSubtotal += item.price * (item.quantity - 1);
                } else {
                    displayPrice = '0';
                    // Do not add to subtotal
                }
            } else {
                displayPrice = (item.price / 100).toFixed(2).replace('.00', '');
                visualSubtotal += item.price * item.quantity;
            }
        } else {
            displayPrice = tengravotal;
            visualSubtotal += item.price * item.quantity;
        }
        // --- END FREE PRODUCT LOGIC ---
        const currencySymbol = shopCurrency === 'GBP' ? '£' : shopCurrency;
        const productImage = '<a class="ajax-cart-item__image_wrap" href="'+ item.url +'"><img class="ajax-cart-item__image" src="' + item.image + '" alt=""></a>';
        const productPrice = '<a class="ajax-cart-item__price" href="'+ item.url +'">' + currencySymbol + displayPrice + '</a>';
        const productTitle = '<a class="ajax-cart-item__title" href="'+ item.url +'">' + Item__title + '</a>';
        const productDelivery = (typeof item.properties['Delivery'] != 'undefined') ? '<div class="delivery_message">'+ item.properties['Delivery'] +'</div>': '';
        const engravtitle =  '<div class="engarav-cart-wrapper">'+ product_List.join(' ') +'</div>';
        const productQuantity = '<div class="qtydiv"><div class="qtybox">'+
            '<span class="btnqty qtyminus icon icon-minus">-</span><input class="quantity-selector quantity-input" id="updates_'+item.id+'" data-variantid="'+item.variant_id+'" type="text" value="'+item.quantity+'"  min="1" pattern="[0-9]*"><span class="btnqty qtyplus icon icon-plus">+</span></div></div>';
        // mobile
        const produtqty = '<div class="mobile_packag_grid"><div class="drop-down">'+ '<select>' + '<option value="Eco Wrap">Eco Wrap</option>' + '<option value="Gift Wrap">Gift Wrap</option>' + '</select>' + '</div></div>';      
        const produtqtymob = '<div class="mobile_qty_selector"><div class="drop_down">'+ '<label class="qty_label_drawer">Quantity</label>' + '<select id="updates_large_" type="text"  value="'+item.quantity+'" class="replace" data-id='+ item.id +'>' +
          '<option value="'+item.quantity+'">'+item.quantity+'</option>' +
          '<option value="1">1 </option>' +
          '<option value="2">2 </option>' +
          '<option value="3">3 </option>' +
          '<option value="4">4 </option>' +
          '<option value="5">5 </option>' +
          '<option value="6">6 </option>' +
          '<option value="7">7 </option>' +
          '<option value="8">8 </option>' +
          '<option value="9">9 </option>' +
          '</select>' + '</div></div>'; 
        const produtdetail = '<div class="product_detail_cart desktop-cart">'+ productTitle + freeNote + productDelivery + engravtitle + productQuantity + '</div>';
        const produtdetailmob = '<div class="product_detail_cart mobile-cart">'+ productTitle + freeNote + produtqtymob + produtqty + '</div>';
        const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '">Remove</div>';
        

        const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + productImage + produtdetail + produtdetailmob + productPrice  + productRemove + '</div>';
        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
    });

    // Update the visual subtotal in the cart drawer
    let formattedSubtotal = (visualSubtotal / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    $('.total_price').text(formattedSubtotal);

    removeFromCart = document.querySelectorAll(defaults.removeFromCart);

    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            const line = this.parentNode.getAttribute('data-line');
            changeItem(line);
        });
    }

    // Always re-bind plus/minus after rendering
    newupdateQtu();
}

function newupdateQtu() {
    $('.btnqty').off('click').on('click', function() {
        var $quantityInput = $(this).parents(".qtybox").find("input");
        var variantId = $quantityInput.attr("data-variantid");
        var currentQty = parseInt($quantityInput.val()) || 0;

        if ($(this).hasClass('qtyplus')) {
            currentQty++;
        } else if ($(this).hasClass('qtyminus')) {
            currentQty = Math.max(0, currentQty - 1);
        }

        $quantityInput.val(currentQty);

        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            data: {
                id: variantId,
                quantity: currentQty
            },
            success: function(cart) {
                updateCartCount(cart.item_count);
                fetchCart(); // Always update UI from server
            }
        });
    });
}

function openCartDrawer() {
    cartDrawer.classList.add('is-open');
  $('body').addClass('open_drawer');
  newupdateQtu();
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
  $('body').removeClass('open_drawer');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}

function openAddModal() {
    cartModal.classList.add('is-open');
}

function closeAddModal() {
    cartModal.classList.remove('is-open');
}

function openCartOverlay() {
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
    closeAddModal();
    closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
    //fetchCart();
    openCartDrawer();
    openCartOverlay();
});
cartDrawerTriggermobile.addEventListener('click', function(event) {
    event.preventDefault();
    //fetchCart();
    openCartDrawer();
    openCartOverlay();
});

// Update mobile quantity selector
$(document).on('change', '.mobile_qty_selector select', function() {
    var variantId = $(this).attr('data-id');
    var quantity = parseInt($(this).val()) || 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: quantity,
            id: variantId
        },
        success: function(cart) {
            updateCartCount(cart.item_count);
            fetchCart(); // Always update UI from server
        }
    });
});

function initializeCartHandlers() {
    // Remove existing handlers
    $(document).off('click', '.btnqty');
    $(document).off('click', '.' + defaults.removeFromCartNoDot);
    $(document).off('change', '.mobile_qty_selector select');

    // Handle plus/minus buttons
    $(document).on('click', '.btnqty', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (isUpdating) return;

        var $button = $(this);
        var $quantityInput = $button.closest(".qtybox").find("input");
        var variantId = $quantityInput.data("variantid");
        var currentQty = parseInt($quantityInput.val()) || 1;
        var newQty = currentQty;
        var $item = $button.closest('.ajax-cart-item__single');
        var line = $item.data('line');
        // Get properties if present
        var properties = undefined;
        var itemIndex = line ? line - 1 : null;
        if (itemIndex !== null && window.cartData && window.cartData.items && window.cartData.items[itemIndex]) {
            var cartItem = window.cartData.items[itemIndex];
            if (cartItem.properties && Object.keys(cartItem.properties).length > 0) {
                properties = cartItem.properties;
            } // else leave as undefined
        }

        if ($button.hasClass('qtyplus')) {
            newQty = Math.min(9, currentQty + 1);
        } else if ($button.hasClass('qtyminus')) {
            if (currentQty > 1) {
                newQty = currentQty - 1;
            } else {
                if (line) {
                    changeItem(line);
                }
                return;
            }
        }

        if (newQty !== currentQty) {
            $quantityInput.val(newQty);
            updateCartQuantity(variantId, newQty, properties);
        }
    });

    // ... rest of the code ...
}

function updateCartQuantity(variantId, quantity, properties, callback) {
    if (!variantId) return;
    var data = {
        id: variantId,
        quantity: quantity
    };
    // Only add properties if it's a non-empty object
    if (properties && Object.keys(properties).length > 0) {
        data.properties = properties;
    }
    console.log('Updating cart:', data);
    $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: data,
        success: function(cart) {
            updateCartCount(cart.item_count);
            updateCartTotal && updateCartTotal(cart.total_price);
            fetchCart();
            if (callback) callback();
        },
        error: function(xhr, status, error) {
            console.error('Failed to update cart:', error);
            fetchCart();
        },
        complete: function() {
            isUpdating = false;
        }
    });
}